import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'
import { getters } from './getters'

/**
 * Módulo de Vuex para el sistema de tour
 */
export const tourStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
